import { appointment } from "@shared/api/services"
import { useMutation, useQueryClient } from "@tanstack/react-query"


export const useAddHomework = (appointmentId, onSuccess = () => {}) => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: appointment.createHomework,
    onSuccess: () => {
      queryClient.invalidateQueries(['appointment', appointmentId])
			onSuccess()
    },
  })

	return mutation
}